import React, { useRef, useState } from "react";
import {
  RecentBattlePlayerType,
  RecentMatchesData,
} from "../../../types/global";
import { CustomIcon } from "../../../components/Icons";
import classNames from "classnames";
import { getProfileURL } from "../../../utils/profile-url";
import { Link } from "react-router-dom";
import { arenaModes, arenaModesIcons } from "../../data/modes";
import { motion } from "framer-motion";
import moment from "moment";
import { BattleFormationRefinedTroop } from "../../types";
import ModifiedStat from "../../../components/ModifiedStat";
import { originalStatsOf } from "../../../utils/statModifiers";
import Button from "../../../components/Button";
import PerfectScroll from "react-perfect-scrollbar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ThousandsSeparator from "../../../utils/thousands-separator";
import { getRange } from "../../../pages/OrderBook/TroopOrderBook";
import LevelBadge from "../../../components/LevelBadge";
import useWindowSize from "../../../hooks/useWindowSize";
import IconButton from "../../../components/IconButton";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

type Props = {
  isLive?: false;
  match: RecentMatchesData["data"][0];
};

const BattleRecordComponent = ({ match, isLive }: Props) => {
  function getMatchDuration(startTime: string, endTime: string) {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const duration = end.getTime() - start.getTime();
    const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((duration % (1000 * 60)) / 1000);

    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  const cardRef = useRef<HTMLDivElement>(null);

  const [isExpanded, setIsExpanded] = useState(false);

  const { width } = useWindowSize();

  if (width < 768) {
    return (
      <div ref={cardRef} className="battle-record-mobile position-relative">
        {/* <CardBg  style={{position:'absolute',top:0,left:0,height:cardHeight}} /> */}
        <div className="d-flex position-relative flex-column gap-1">
          <div className="d-flex  justify-content-start gap-1 flex-row  align-items-center">
            <PlayerAvatar
              {...match.players[0]}
              isThereWinner={match.isThereWinner!}
            />
            <div className="d-flex flex-column align-items-center">
              <img
                src="/assets/images/icons/blades.png"
                width={30}
                height={30}
              />
              <span className="fs-tiny dark-yellow">
                {getMatchDuration(match.startTime, match.endTime)}
              </span>
            </div>
            <PlayerAvatar
              {...match.players[1]}
              isThereWinner={match.isThereWinner!}
            />
            <Link
              to={"/arena/live?replayId=" + match.id}
              className="ms-auto me-1"
            >
              <IconButton
                style={{ width: 33, height: 33 }}
                icon={
                  <img
                    width={10}
                    style={{ marginInlineStart: 2 }}
                    src="/assets/images/icons/play.svg"
                  />
                }
              />
            </Link>
          </div>
          <div className="d-flex gap-2 flex-row align-items-center justify-content-start">
            <div className="fs-med d-flex align-items-center ">
              <CustomIcon
                className="fs-med"
                icon="timer"
                width={18}
                height={18}
              />
              {moment(match.startTime).format("DD/MM/YYYY")}
            </div>
            <div className="dark-yellow gap-1 d-flex align-items-center">
              <img
                src={arenaModesIcons[match.adventureMode]}
                width={18}
                height={18}
              />
              <span className="fs-med dark-yellow">
                {arenaModes[match.adventureMode]}
              </span>
            </div>
          </div>
          <div className="d-flex gap-2 mt-0 flex-column align-items-center justify-content-center">
            <motion.div
              className="d-flex flex-column gap-1 "
              animate={{
                height: isExpanded ? 60 : 0,
              }}
            >
              <TroopRow
                isThereWinner={match.isThereWinner!}
                troops={match.attackerTroops}
                className={
                  match.isThereWinner
                    ? match.players.find((p) => p.isWinner && p.isAttacker)
                      ? "attacker"
                      : "defender"
                    : ""
                }
                placeHolder={match.attackerTroops?.length === 0}
              />
              <TroopRow
                isThereWinner={match.isThereWinner!}
                placeHolder={match.defenderTroops?.length === 0}
                className={
                  match.isThereWinner
                    ? match.players.find((p) => p.isWinner && !p.isAttacker)
                      ? "attacker"
                      : "defender"
                    : ""
                }
                troops={match.defenderTroops}
              />
            </motion.div>
            <div
              role="button"
              onClick={() => setIsExpanded((prev) => !prev)}
              className="fs-med d-flex pointer align-items-center  dark-yellow gap-1"
            >
              <CustomIcon
                className="fs-med transition"
                icon="arrow"
                width={17}
                height={11}
                style={{
                  transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
              {isExpanded ? "Show less" : "Show troops"}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row justify-content-between battle-record  p-3 mb-2 rounded bg-2 ">
      <div className="d-flex col-4  col-lg-4 justify-content-center flex-row gap-3 align-items-center">
        <PlayerAvatar
          {...match.players[0]}
          isThereWinner={match.isThereWinner!}
        />
        <div className="d-flex flex-column align-items-center">
          <img src="/assets/images/icons/blades.png" width={30} height={30} />
          <span className="fs-med dark-yellow">
            {getMatchDuration(match.startTime, match.endTime)}
          </span>
        </div>
        <PlayerAvatar
          {...match.players[1]}
          isThereWinner={match.isThereWinner!}
        />
      </div>
      <div className="d-flex col-4  col-lg-3 gap-1 flex-column align-items-center">
        <TroopRow
          isThereWinner={match.isThereWinner!}
          troops={match.attackerTroops}
          className={
            match.isThereWinner
              ? match.players.find((p) => p.isWinner && p.isAttacker)
                ? "attacker"
                : "defender"
              : ""
          }
          placeHolder={match.attackerTroops?.length === 0}
        />
        <TroopRow
          isThereWinner={match.isThereWinner!}
          placeHolder={match.defenderTroops?.length === 0}
          className={
            match.isThereWinner
              ? match.players.find((p) => p.isWinner && !p.isAttacker)
                ? "attacker"
                : "defender"
              : ""
          }
          troops={match.defenderTroops}
        />
      </div>
      <div className="d-flex col-6  col-lg-3 flex-column align-items-center justify-content-center">
        <div className="fs-big ">
          {moment(match.startTime).format("MM/DD/YYYY - hh:mm")}
        </div>
        <div className="dark-yellow gap-1 d-flex align-items-center">
          <img
            src={arenaModesIcons[match.adventureMode]}
            width={18}
            height={18}
          />
          <span className="fs-med dark-yellow">
            {arenaModes[match.adventureMode]}
          </span>
        </div>
      </div>
      <div className="d-flex col-6 col-lg-2  flex-column justify-content-center align-items-center">
        <Link to={"/arena/live?replayId=" + match.id}>
          <Button variant="primary" className="bg-100 gap-2">
            <CustomIcon
              width={10}
              icon="play"
              type="svg"
              className="opacity-50"
            />
            Replay
          </Button>
        </Link>
      </div>
    </div>
  );
};

const PlayerAvatar = (
  player: RecentBattlePlayerType & { isThereWinner: boolean }
) => (
  <Link
    to={"/profile/" + player.playerId}
    className="d-flex flex-column gap-1 align-items-center match-profile-box-container"
  >
    <div className="match-profile-box">
      {player.isThereWinner && player.isWinner && (
        <div className="winner-crown">
          <img
            src="/assets/images/icons/mini-crown.png"
            width={30}
            height={30}
          />
        </div>
      )}
      <img
        className={classNames("circle", {
          "pvt-shadow": !player.photoFile,
        })}
        src={
          player.photoFile
            ? getProfileURL(player.playerId, player.photoFile)!
            : "/assets/images/empty-avatar.png"
        }
        width={"100%"}
        height={"100%"}
      />
    </div>
    <span
      style={{ maxWidth: "80px" }}
      className={classNames(
        "text-truncate fs-med  br-username ",
        { "text-success-light": player.isWinner && player.isThereWinner },
        { "text-danger": !player.isWinner && player.isThereWinner },
        { "dark-yellow": !player.isThereWinner }
      )}
    >
      {player.username}
    </span>
  </Link>
);

const TroopRow = ({
  troops,
  placeHolder,
  className,
}: {
  troops?: BattleFormationRefinedTroop[];
  isThereWinner?: boolean;
  placeHolder?: boolean;
  className?: string;
}) => {
  const { t } = useAppTranslation("battle");
  return (
    <PerfectScroll
      className="w-100 "
      style={{ maxWidth: "100%", height: "auto", overflowY: "hidden" }}
    >
      <div className="d-flex gap-1 flex-row justify-content-start w-fit mx-auto py-0 align-items-center">
        {(!troops || troops?.length === 0 || placeHolder) &&
          new Array(4).fill(0).map((_, i) => (
            <div className="empty-troop" key={i}>
              <CustomIcon
                width={20}
                height={20}
                icon="person"
                className="opacity-50"
              />
            </div>
          ))}
        {troops?.map((troop) => (
          <OverlayTrigger
            placement={"bottom"}
            trigger={"hover"}
            key={troop.id}
            overlay={
              <Tooltip>
                <div className="d-flex gap-3 align-items-center">
                  <div className="d-flex flex-column align-items-center">
                    <div className="position-relative">
                      <img src={troop.image} width={80} />
                      {troop.count > 1 && (
                        <div className="badge position-absolute p-1 bg-danger inline-block count bold top-0 start-0  ">
                          {troop.count}x
                        </div>
                      )}
                    </div>
                    <div className="fs-med d-flex align-items-center gap-1 bold">
                      {troop.name}{" "}
                    </div>
                    <div className="fs-sm">
                      {troop.level > 0 && (
                        <div className="level fs-small d-flex align-items-center">
                          Level{" "}
                          <LevelBadge
                            style={{
                              position: "static",
                              display: "inline-block",
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                            level={troop.level}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex ps-2 border-l-1 border-white flex-column align-items-start gap-1 pe-2">
                    <div className="text-center">
                      <div className="fs-small bold">{t("battleRecord.stats")}</div>
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                      <img
                        src="/assets/images/icons/health.png"
                        width={16}
                        height={18}
                      />
                      <div className="fs-small">
                        <ModifiedStat
                          value={ThousandsSeparator(troop.stats.MaxHealth)}
                          original={
                            originalStatsOf(troop)?.maxHealth === undefined
                              ? undefined
                              : ThousandsSeparator(originalStatsOf(troop)!.maxHealth!)
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                      <img
                        src="/assets/images/icons/damage.png"
                        width={16}
                        height={18}
                      />
                      <div className="fs-small">
                        <ModifiedStat
                          value={ThousandsSeparator(troop.stats.Damage)}
                          original={
                            originalStatsOf(troop)?.damage === undefined
                              ? undefined
                              : ThousandsSeparator(originalStatsOf(troop)!.damage!)
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                      <img
                        src="/assets/images/icons/armor.png"
                        width={16}
                        height={18}
                      />
                      <div className="fs-small">
                        <ModifiedStat
                          value={troop.stats.Armor}
                          original={originalStatsOf(troop)?.armor}
                        />
                      </div>
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                      <img
                        src="https://core.chainoflegends.com/assets/images/team-magic-resist.png"
                        width={16}
                        height={18}
                      />
                      <div className="fs-small">
                        <ModifiedStat
                          value={ThousandsSeparator(troop.stats.MagicResistance)}
                          original={
                            originalStatsOf(troop)?.magicResistance === undefined
                              ? undefined
                              : ThousandsSeparator(originalStatsOf(troop)!.magicResistance!)
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                      <img
                        src="/assets/images/icons/range.png"
                        width={16}
                        height={18}
                      />
                      <div className="fs-small">
                        {getRange(troop.range, troop.level, troop.troopId)}
                      </div>
                    </div>
                  </div>
                </div>
              </Tooltip>
            }
          >
            <div
              style={{ position: "relative", zIndex: 10 }}
              className={classNames(
                "d-flex flex-column align-items-center troop-circle",
                className
              )}
            >
              {troop.level > 0 && <div className="level">{troop.level}</div>}
              <img src={troop.icon} className="troop-icon-battle-record" />
              {troop.count > 1 && <div className="count">{troop.count}x</div>}
            </div>
          </OverlayTrigger>
        ))}
      </div>
    </PerfectScroll>
  );
};

export default BattleRecordComponent;
